import React, { useState, useEffect, useRef } from "react";
import { Container } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import S3FileUpload from "react-s3";
import Swal from "sweetalert2";

function ChangePassword() {
  const [image, setImage] = useState(null);
  const [secure, setSecure] = useState(false);
  const user = useSelector((state) => state.User);
  const dispatch = useDispatch();

  //   console.log("Profile>>>", user?.user);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  const new_password = useRef({});
  new_password.current = watch("new_password", "");

  // Todo: onSubmit
  const onSubmit = (data) => {
    console.log("data>>>", data);
    apiReq(
      url.CHANGE_PASSWORD + user?.user?._id,
      {
        current_password: data.password,
        password: data.new_password,
      },
      "put",
      {
        Authorization: `Bearer ${user.user?.token}`,
      }
    )
      .then((res) => {
        if (res.success) {
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          reset();
        } else {
          Swal.fire({
            title: "Error",
            text: res.message,
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      })
      .catch((err) => {
        console.log("err>>>", err);
      });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="card-title">Change Password</h5>
                </div>
              </div>
              <hr />
              <div className="d-flex mt-3">
                <div className="profile_details_wrapper">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-4">
                      <label>Current Password</label>
                      <input
                        type="password"
                        className="form-control form-control-lg input-lg"
                        {...register("password", {
                          required: "You must specify a password",
                          minLength: {
                            value: 8,
                            message: "Password must have at least 8 characters",
                          },
                          pattern: {
                            value:
                              /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}/,
                            message:
                              "Please use atleast 1 special character, and 1 capital letter in the password.",
                          },
                        })}
                      />
                      {errors.password && (
                        <span className="text-danger">
                          {errors.password.message}
                        </span>
                      )}
                    </div>
                    <div className="mb-4">
                      <label>New Password</label>
                      <input
                        type="password"
                        className="form-control form-control-lg input-lg"
                        {...register("new_password", {
                          required: "You must specify a password",
                          minLength: {
                            value: 8,
                            message: "Password must have at least 8 characters",
                          },
                          pattern: {
                            value:
                              /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}/,
                            message:
                              "Please use atleast 1 special character, and 1 capital letter in the password.",
                          },
                        })}
                      />
                      {errors.new_password && (
                        <span className="text-danger">
                          {errors.new_password.message}
                        </span>
                      )}
                    </div>
                    <div className="mb-4">
                      <label>Confirm New Password</label>
                      <input
                        type="password"
                        className="form-control form-control-lg input-lg"
                        {...register("confirm_new_password", {
                          validate: (value) =>
                            value === new_password.current ||
                            "The passwords do not match",
                        })}
                      />
                      {errors.confirm_new_password && (
                        <span className="text-danger">
                          {errors.confirm_new_password.message}
                        </span>
                      )}
                    </div>
                    <hr />
                    <div className="mb-2">
                      <button className="btn btn-primary" type="submit">
                        Update profile
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default ChangePassword;
